"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 9.4.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TumorProfilingReasonForTestingDtoReasonForTestEnum = exports.TumorProfilingReasonForTestingDtoDiseaseStatusEnum = void 0;
exports.TumorProfilingReasonForTestingDtoDiseaseStatusEnum = {
    LocalizedPrimary: 'disease_status_localized_primary',
    LocallyAdvanced: 'disease_status_locally_advanced',
    Metastatic: 'disease_status_metastatic',
    RecurrentLocal: 'disease_status_recurrent_local',
    RecurrentDistant: 'disease_status_recurrent_distant',
    Refractory: 'disease_status_refractory',
    Diagnostic: 'disease_status_diagnostic',
    Remission: 'disease_status_remission',
    Relapse: 'disease_status_relapse'
};
exports.TumorProfilingReasonForTestingDtoReasonForTestEnum = {
    BreastCancerHormoneReceptorPositive: 'breast_cancer_hormone_receptor_positive',
    BreastCancerHer2Positive: 'breast_cancer_her2_positive',
    BreastCancerTripleNegative: 'breast_cancer_triple_negative',
    BreastCancerNotProvided: 'breast_cancer_not_provided',
    ColorectalCancer: 'colorectal_cancer',
    Melanoma: 'melanoma',
    Nsclc: 'nsclc',
    ProstateCancer: 'prostate_cancer',
    OvarianCancer: 'ovarian_cancer'
};
